import { HgSupportedLanguage } from '@smg-real-estate/domus';

// this is a method and PLATFORM_BASE_URL defined inside to be read only when its called because its difficult to test otherwise,
// the file is loaded and PLATFORM_BASE_URL would be set to undefined before the `beforeEach` is executed, so this is a way to defer its reading
// this is a sign that we're doing something wrong which we are, global variables are bad
export function getCmbFormUrlsByLocale(): { [key: string]: string } {
  const PLATFORM_BASE_URL = import.meta.env.VUE_APP_BASE_URL;
  return {
    [HgSupportedLanguage.EN]: `${PLATFORM_BASE_URL}/en/financing/mortgage-advice`,
    [HgSupportedLanguage.DE]: `${PLATFORM_BASE_URL}/de/finanzieren/hypotheken-beratung`,
    [HgSupportedLanguage.FR]: `${PLATFORM_BASE_URL}/fr/financement/conseil-hypothecaire`,
    [HgSupportedLanguage.IT]: `${PLATFORM_BASE_URL}/it/finanziamento/consulenza-ipotecaria`,
  };
}
